var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 40 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#fff",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M12.5 27.737V12.264a.75.75 0 0 1 1.11-.659l14.183 7.737a.75.75 0 0 1 0 1.317l-14.184 7.736a.75.75 0 0 1-1.109-.658"
})));
export default SvgPlay;